declare namespace $ {

	export class $giper_baza_unit_sand_dump extends $giper_baza_vary_edit {
		land( ): $giper_baza_land
		sand( ): $giper_baza_unit_sand
	}
	
}

//# sourceMappingURL=dump.view.tree.d.ts.map